export const showCatalogFilters = (
  category: { id: number; show_filters?: boolean } | null,
  searchShowFilters: boolean | undefined,
): boolean => (
  category?.id
    ? category.show_filters !== false
    : searchShowFilters !== false
);
